export default "__VITE_ASSET__60OmhfBl__"